import Compressor from './Compressor';
export default Compressor;